import React, { useState, Fragment } from 'react';
import Container from './guides/Container';
import { Tab } from 'Components/commonComponents';
import { ClickLayer } from '../../ga4';

import './lensCare.scss';

const LensCare = () => {
  const [showInsertion, setShowInsertion] = useState(true);
  const insertionClassName = showInsertion
    ? 'tabs--item tabs--insertion active'
    : 'tabs--item tabs--insertion';
  const removalClassName = showInsertion
    ? 'tabs--item tabs--removal'
    : 'tabs--item tabs--removal active';

  return (
    <Fragment>
      <Container
          type="insertion"
          id="guides.how_to_put_on_lens"
          title="HOW TO PUT ON CONTACT LENS IN 4 EASY STEPS"
          active={showInsertion?' active':''}
        />
      <Container
          type="removal"
          id="guides.how_to_remove_lens"
          title="HOW TO REMOVE YOUR CONTACTS IN 4 EASY STEPS"
          active={showInsertion?'':' active'}
        />
      <ul className="tabs--wrapper tabs--lenscare">
        <Tab
          id="tabs.insertion"
          title="Insertion"
          className={insertionClassName}
          onClick={() => {
            setShowInsertion(true);
            ClickLayer('tab--lenscare');
          }}
        />
        <Tab
          id="tabs.removal"
          title="Removal"
          className={removalClassName}
          onClick={() => {
            setShowInsertion(false);
            ClickLayer('tab--removal');
          }}
        />
      </ul>
    </Fragment>
  );
};

export default LensCare;
